import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCPIXT9eN_wrIyFhrA9eODQsbxTxObm0xE",
  authDomain: "nebula-maze.firebaseapp.com",
  projectId: "nebula-maze",
  storageBucket: "nebula-maze.firebasestorage.app",
  messagingSenderId: "489783786014",
  appId: "1:489783786014:web:f77ea2ccc0b9679392cc0f",
  measurementId: "G-8E14M82719"
};

export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
